module.exports = require('./helpers/bundle-url').getBundleURL('c9mUi') + "logo.7718c6df.svg";